// extracted by mini-css-extract-plugin
export default {"baseView":"InstitutionMgmt_baseView__JnCeR"};